import { observable, flow, action, toJS } from "mobx";
import { getOptions } from "services/api";
import mergeWith from "lodash/mergeWith";
import cloneDeepWith from "lodash/cloneDeepWith";
import isObject from "lodash/isObject";

import { message } from "antd";
import { registerHandler, delay, checkIndexerBalance } from "services/api";
import {
	addProxies,
	deleteProxies,
	checkProxies,
	stopCheckingProxies,
	saveOptions,
	addBlockedSites,
	deleteBlockedSites
} from "services/options";
import { IndexingServices } from "common/general";

class OptionsStore {
	constructor() {
		this.initUI();
	}
	@observable
	options = null;
	@observable
	stateForm = null;
	@observable
	proxies = [];
	@observable
	proxyMonitorState = "NEW";
	@observable
	blockedSites = [];
	// @observable
	// ui = {
	// 	initTab: "general",
	// 	updatedProxy: null,
	// 	deletedProxies: [],
	// 	addProxiesDialogVisible: false,
	// 	addingProxies: false,
	// 	deletingProxies: false,
	// 	savingOptions: false,
	// 	indexerStatus: {}
	// };
	
	initUI = () => {
		let indexerStatus = {};

		IndexingServices.map(service => {
			indexerStatus[service.name] = {
				status: "",
				validating: false
			}
		});

		this.ui = observable.object({
			initTab: "general",
			updatedProxy: null,
			deletedProxies: [],
			addedBlockedSites: [],
			deletedBlockedSites: [],
			addProxiesDialogVisible: false,
			addBlockedSitesDialogVisible: false,
			addingProxies: false,
			deletingProxies: false,
			addingBlockedSites: false,
			deletingBlockedSites: false,
			savingOptions: false,
			indexerStatus: observable.object(indexerStatus)
		});
	};

	getRawObjectFromStateForm = () => {
		function customizer(value) {
			if (isObject(value)) {
				if ("value" in value) {
					return value.value;
				}
			}
		}
		let rawJS = toJS(this.stateForm);
		return cloneDeepWith(rawJS, customizer);
	};

	createStateForm = options => {
		function customizer(value, key) {
			if (!isObject(value) && key !== "value") {
				return {
					value: value
				};
			}
		}

		let newObj = cloneDeepWith(toJS(options), customizer);
		return newObj;
		// return {
		// 	//General
		// 	maxNumberOfRetries: {
		// 		value: options.maxNumberOfRetries
		// 	},
		// 	maxPostingThreads: {
		// 		value: options.maxPostingThreads
		// 	},
		// 	maxBrowserThreads: {
		// 		value: options.maxBrowserThreads
		// 	},
		// 	automaticSignIn: {
		// 		value: options.automaticSignIn
		// 	},
		// 	automaticBackup: {
		// 		value: options.automaticBackup
		// 	},
		// 	//Captcha
		// 	autoSolveCaptcha: {
		// 		value: options.autoSolveCaptcha
		// 	},
		// 	primaryCaptchaService: {
		// 		value: options.primaryCaptchaService
		// 	},
		// 	primaryTwoCaptchaInfo: {
		// 		captchaKey: {
		// 			value: options.primaryTwoCaptchaInfo.captchaKey
		// 		}
		// 	},
		// 	primaryDeathByCaptchaInfo: {
		// 		username: {
		// 			value: options.primaryDeathByCaptchaInfo.username
		// 		},
		// 		password: {
		// 			value: options.primaryDeathByCaptchaInfo.password
		// 		}
		// 	},
		// 	primaryImageTypersInfo: {
		// 		username: {
		// 			value: options.primaryImageTypersInfo.username
		// 		},
		// 		password: {
		// 			value: options.primaryImageTypersInfo.password
		// 		}
		// 	},
		// 	primaryAntiCaptchaInfo: {
		// 		captchaKey: {
		// 			value: options.primaryAntiCaptchaInfo.captchaKey
		// 		}
		// 	},
		// 	primaryDecaptcherInfo: {
		// 		username: {
		// 			value: options.primaryDecaptcherInfo.username
		// 		},
		// 		password: {
		// 			value: options.primaryDecaptcherInfo.password
		// 		}
		// 	},
		// 	primaryBeatCaptchaInfo: {
		// 		captchaKey: {
		// 			value: options.primaryBeatCaptchaInfo.captchaKey
		// 		}
		// 	},
		// 	primaryBypassCaptchaInfo: {
		// 		captchaKey: {
		// 			value: options.primaryBypassCaptchaInfo.captchaKey
		// 		}
		// 	},
		// 	primaryRemoteOCRInfo: {
		// 		address: {
		// 			value: options.primaryRemoteOCRInfo.address
		// 		},
		// 		key: {
		// 			value: options.primaryRemoteOCRInfo.key
		// 		}
		// 	},
		// 	useSecondaryCaptchaService: {
		// 		value: options.useSecondaryCaptchaService
		// 	},
		// 	secondaryCaptchaService: {
		// 		value: options.secondaryCaptchaService
		// 	},
		// 	secondaryTwoCaptchaInfo: {
		// 		captchaKey: {
		// 			value: options.secondaryTwoCaptchaInfo.captchaKey
		// 		}
		// 	},
		// 	secondaryDeathByCaptchaInfo: {
		// 		username: {
		// 			value: options.secondaryDeathByCaptchaInfo.username
		// 		},
		// 		password: {
		// 			value: options.secondaryDeathByCaptchaInfo.password
		// 		}
		// 	},
		// 	secondaryImageTypersInfo: {
		// 		username: {
		// 			value: options.secondaryImageTypersInfo.username
		// 		},
		// 		password: {
		// 			value: options.secondaryImageTypersInfo.password
		// 		}
		// 	},
		// 	secondaryAntiCaptchaInfo: {
		// 		captchaKey: {
		// 			value: options.secondaryAntiCaptchaInfo.captchaKey
		// 		}
		// 	},
		// 	secondaryDecaptcherInfo: {
		// 		username: {
		// 			value: options.secondaryDecaptcherInfo.username
		// 		},
		// 		password: {
		// 			value: options.secondaryDecaptcherInfo.password
		// 		}
		// 	},
		// 	secondaryBeatCaptchaInfo: {
		// 		captchaKey: {
		// 			value: options.secondaryBeatCaptchaInfo.username
		// 		}
		// 	},
		// 	secondaryBypassCaptchaInfo: {
		// 		captchaKey: {
		// 			value: options.secondaryBypassCaptchaInfo.captchaKey
		// 		}
		// 	},
		// 	secondaryRemoteOCRInfo: {
		// 		address: {
		// 			value: options.secondaryRemoteOCRInfo.address
		// 		},
		// 		key: {
		// 			value: options.secondaryRemoteOCRInfo.key
		// 		}
		// 	},
		// 	//GoogleNoCaptcha
		// 	useGoogleNoCaptcha: {
		// 		value: options.useGoogleNoCaptcha
		// 	},
		// 	googleNoCaptchaService: {
		// 		value: options.googleNoCaptchaService
		// 	},
		// 	googleNoCaptchaTwoCaptchaInfo: {
		// 		captchaKey: {
		// 			value: options.googleNoCaptchaTwoCaptchaInfo.captchaKey
		// 		}
		// 	},
		// 	googleNoCaptchaDBCInfo: {
		// 		username: {
		// 			value: options.googleNoCaptchaDBCInfo.username
		// 		},
		// 		password: {
		// 			value: options.googleNoCaptchaDBCInfo.password
		// 		}
		// 	},
		// 	googleNoCaptchaImageTypersInfo: {
		// 		username: {
		// 			value: options.googleNoCaptchaImageTypersInfo.username
		// 		},
		// 		password: {
		// 			value: options.googleNoCaptchaImageTypersInfo.password
		// 		}
		// 	},
		// 	googleNoCaptchaAntiCaptchaInfo: {
		// 		captchaKey: {
		// 			value: options.googleNoCaptchaAntiCaptchaInfo.captchaKey
		// 		}
		// 	},
		// 	googleNoCaptchaRemoteOCRInfo: {
		// 		address: {
		// 			value: options.googleNoCaptchaRemoteOCRInfo.address
		// 		},
		// 		key: {
		// 			value: options.googleNoCaptchaRemoteOCRInfo.key
		// 		}
		// 	},
		// 	useSecondaryGoogleNoCaptcha: {
		// 		value: options.useSecondaryGoogleNoCaptcha
		// 	},
		// 	secondaryGoogleNoCaptchaService: {
		// 		value: options.secondaryGoogleNoCaptchaService
		// 	},
		// 	secondaryGoogleNoCaptchaTwoCaptchaInfo: {
		// 		captchaKey: {
		// 			value: options.secondaryGoogleNoCaptchaTwoCaptchaInfo.captchaKey
		// 		}
		// 	},
		// 	secondaryGoogleNoCaptchaDBCInfo: {
		// 		username: {
		// 			value: options.secondaryGoogleNoCaptchaDBCInfo.username
		// 		},
		// 		password: {
		// 			value: options.secondaryGoogleNoCaptchaDBCInfo.password
		// 		}
		// 	},
		// 	secondaryGoogleNoCaptchaImageTypersInfo: {
		// 		username: {
		// 			value: options.secondaryGoogleNoCaptchaImageTypersInfo.username
		// 		},
		// 		password: {
		// 			value: options.secondaryGoogleNoCaptchaImageTypersInfo.password
		// 		}
		// 	},
		// 	secondaryGoogleNoCaptchaAntiCaptchaInfo: {
		// 		captchaKey: {
		// 			value: options.secondaryGoogleNoCaptchaAntiCaptchaInfo.captchaKey
		// 		}
		// 	},
		// 	secondaryGoogleNoCaptchaRemoteOCRInfo: {
		// 		address: {
		// 			value: options.secondaryGoogleNoCaptchaRemoteOCRInfo.address
		// 		},
		// 		key: {
		// 			value: options.secondaryGoogleNoCaptchaRemoteOCRInfo.key
		// 		}
		// 	},
		// 	//Article Builder
		// 	articleBuilder: {
		// 		username: {
		// 			value: options.articleBuilder.username
		// 		},
		// 		password: {
		// 			value: options.articleBuilder.password
		// 		},
		// 		articleCount: {
		// 			value: options.articleBuilder.articleCount
		// 		}
		// 	},
		// 	//Spinners
		// 	tbs: {
		// 		username: {
		// 			value: options.tbs.username
		// 		},
		// 		password: {
		// 			value: options.tbs.password
		// 		},
		// 		maxSyns: {
		// 			value: options.tbs.maxSyns
		// 		},
		// 		quality: {
		// 			value: options.tbs.quality
		// 		}
		// 	},
		// 	wordAi: {
		// 		email: {
		// 			value: options.wordAi.email
		// 		},
		// 		password: {
		// 			value: options.wordAi.password
		// 		},
		// 		quality: {
		// 			value: options.wordAi.quality
		// 		},
		// 		nonested: {
		// 			value: options.wordAi.nonested
		// 		},
		// 		sentence: {
		// 			value: options.wordAi.sentence
		// 		},
		// 		paragraph: {
		// 			value: options.wordAi.paragraph
		// 		}
		// 	},
		// 	spinRewriter: {
		// 		email: {
		// 			value: options.spinRewriter.email
		// 		},
		// 		apiKey: {
		// 			value: options.spinRewriter.apiKey
		// 		},
		// 		confidenceLevel: {
		// 			value: options.spinRewriter.confidenceLevel
		// 		},
		// 		protectedTerms: {
		// 			value: options.spinRewriter.protectedTerms
		// 		},
		// 		nestedSpintax: {
		// 			value: options.spinRewriter.nestedSpintax
		// 		},
		// 		paragraphs: {
		// 			value: options.spinRewriter.paragraphs
		// 		},
		// 		newParagraphs: {
		// 			value: options.spinRewriter.newParagraphs
		// 		},
		// 		sentences: {
		// 			value: options.spinRewriter.sentences
		// 		},
		// 		sentenceTrees: {
		// 			value: options.spinRewriter.sentenceTrees
		// 		}
		// 	},
		// 	eSpinner: {
		// 		email: {
		// 			value: options.eSpinner.email
		// 		},
		// 		apiKey: {
		// 			value: options.eSpinner.apiKey
		// 		}
		// 	},
		// 	spinea: {
		// 		email: {
		// 			value: options.spinea.email
		// 		},
		// 		apiKey: {
		// 			value: options.spinea.apiKey
		// 		}
		// 	},
		// 	spinnerBR: {
		// 		username: {
		// 			value: options.spinnerBR.username
		// 		},
		// 		apiKey: {
		// 			value: options.spinnerBR.apiKey
		// 		}
		// 	},
		// 	spinnerComBr: {
		// 		apiKey: {
		// 			value: options.spinnerComBr.apiKey
		// 		}
		// 	},
		// 	//Indexer
		// 	indexer: {
		// 		instantLinkIndexerApiKey: {
		// 			value: options.indexer.instantLinkIndexerApiKey
		// 		},
		// 		backLinksIndexerApiKey: {
		// 			value: options.indexer.backLinksIndexerApiKey
		// 		},
		// 		eliteLinkIndexerApiKey: {
		// 			value: options.indexer.eliteLinkIndexerApiKey
		// 		},
		// 		indexificationApiKey: {
		// 			value: options.indexer.indexificationApiKey
		// 		},
		// 		linkIndexrApiKey: {
		// 			value: options.indexer.linkIndexrApiKey
		// 		},
		// 		expressIndexerApiKey: {
		// 			value: options.indexer.expressIndexerApiKey
		// 		},
		// 		web20IndexerApiKey: {
		// 			value: options.indexer.web20IndexerApiKey
		// 		},
		// 		cloudIndexerApiKey: {
		// 			value: options.indexer.cloudIndexerApiKey
		// 		},
		// 		speedLinkApiKey: {
		// 			value: options.indexer.speedLinkApiKey
		// 		},
		// 		fastLinkIndexerApiKey: {
		// 			value: options.indexer.fastLinkIndexerApiKey
		// 		},
		// 		linkProcessorApiKey: {
		// 			value: options.indexer.linkProcessorApiKey
		// 		},
		// 		linkCentaurApiKey: {
		// 			value: options.indexer.linkCentaurApiKey
		// 		},
		// 		lIndexedApiKey: {
		// 			value: options.indexer.lIndexedApiKey
		// 		}
		// 	},
		// 	//RankerXIndexer
		// 	rankerxIndexerAccountDelay: {
		// 		value: options.rankerxIndexerAccountDelay
		// 	},
		// 	rankerxIndexerDailySubmissionPerAccount: {
		// 		value: options.rankerxIndexerDailySubmissionPerAccount
		// 	},
		// 	maxIndexerThreads: {
		// 		value: options.maxIndexerThreads
		// 	},
		// 	additionalSitesToIndexedByRankerXIndexer: {
		// 		value: options.additionalSitesToIndexedByRankerXIndexer
		// 	},
		// 	//Proxy
		// 	useProxyForPosting: {
		// 		value: options.useProxyForPosting
		// 	}
		// };
	};

	@action
	showAddProxiesDialog = () => {
		this.ui.addProxiesDialogVisible = true;
	};

	@action
	showAddBlockedSitesDialog = () => {
		this.ui.addBlockedSitesDialogVisible = true;
	}

	@action
	hideAddProxiesDialog = () => {
		this.ui.addProxiesDialogVisible = false;
	};

	@action
	hideAddBlockedSitesDialog = () => {
		this.ui.addBlockedSitesDialogVisible = false;
	}

	remoteDeleteBlockedSites = flow(function*(blockedSites){
		this.ui.deletingBlockedSites = true;
		const response = yield deleteBlockedSites(blockedSites);
		this.ui.deletingBlockedSites = false;

		if (response == null) {
			message.error("Unable to delete the blocked sites. Unknown error.", 3);
			return;
		}

		if (response.error) {
			message.error(response.error.message, 3);
			return;
		}

		message.success("Successfully deleted selected proxies");
	})

	remoteDeleteProxies = flow(function*(proxies) {
		this.ui.deletingProxies = true;
		const response = yield deleteProxies(proxies);
		this.ui.deletingProxies = false;

		if (response == null) {
			message.error("Unable to delete the proxies. Unknown error.", 3);
			return;
		}

		if (response.error) {
			message.error(response.error.message, 3);
			return;
		}

		message.success("Successfully deleted selected proxies");
	});

	customizer = (objValue, srcValue, key, object, source, stack) => {
		// console.log(key + " " + JSON.stringify(objValue) + " " + JSON.stringify(srcValue) + " " + isObject(srcValue));
		// if (isObject(objValue || isObject(srcValue))) {
		//   return undefined;
		// }
		// console.log(objValue + " " + srcValue);
		if (srcValue == undefined) {
			return null;
		}
	};

	@action
	formChanged = fields => {		
		mergeWith(this.stateForm, fields, this.customizer);		
	};

	@action
	addBlockedSites = (blockedSites) => {
		this.ui.addedBlockedSites = blockedSites;
	}

	@action
	updateProxy = proxy => {
		this.ui.updatedProxy = proxy;
	};

	@action
	deleteBlockedSites = blockedSites => {
		this.ui.deletedBlockedSites = blockedSites;
	}

	@action
	deleteProxies = proxies => {
		this.ui.deletedProxies = proxies;
	};

	@action
	changeProxyMonitorState = state => {
		this.proxyMonitorState = state;
	};

	checkIndexerBalance = flow(function*(indexer, apiKey) {
		this.ui.indexerStatus[indexer].validating = true;
		const response = yield checkIndexerBalance({
			indexerSource: indexer,
			apiKey: apiKey
		});
		this.ui.indexerStatus[indexer].validating = false;
		if (response == null) {
			message.error("Failed to check the balance");
			return;
		}
		if (response.error) {
			message.error(response.error.message);
			return;
		}
		// console.log(indexer);
		this.ui.indexerStatus[indexer].status = response.balance;
		// console.log(this.ui.indexerStatus);
	});

	checkProxies = flow(function*() {
		const response = yield checkProxies();
		if (response == null) {
			message.error("Failed to start checking proxies", 5);
			return;
		}
		if (response.error) {
			message.error(response.error.message, 5);
			return;
		}
		message.success("Successfully started checking proxies");
	});

	stopCheckingProxies = flow(function*() {
		const response = yield stopCheckingProxies();
		if (response == null) {
			message.error("Failed to stop checking proxies", 5);
			return;
		}
		if (response.error) {
			message.error(response.error.message, 5);
			return;
		}
		message.success("Successfully stopped checking proxies");
	});

	remoteAddProxies = flow(function*(proxies) {
		this.ui.addingProxies = true;
		const response = yield addProxies(proxies);
		this.ui.addingProxies = false;
		if (response == null) {
			message.error("Failed to add errors. Unknown errors.", 3);
			return;
		}
		if (response.error) {
			message.error(response.error.message, 3);
			return;
		}
		message.success("Successfully added new proxies");
		this.ui.addProxiesDialogVisible = false;
	});

	remoteAddBlockedSites = flow(function*(blockedSites) {
		this.ui.addingBlockedSites = true;
		const response = yield addBlockedSites(blockedSites);
		this.ui.addingBlockedSites = false;
		if (response == null) {
			message.error("Failed to add blocked sites. Unknown error.", 3);
			return;
		}

		if (response.error) {
			message.error(response.error.message, 3);
			return;
		}
		message.success("Successfully added new blocked sites");
		this.ui.addBlockedSitesDialogVisible = false;
	});

	remoteSaveOptions = flow(function*() {
		this.ui.savingOptions = true;
		yield delay(500);
		let obj = this.getRawObjectFromStateForm();		
		const response = yield saveOptions(obj);
		this.ui.savingOptions = false;
		if (response == null) {
			message.error("Unable to save options. Unknown error", 5);
			return;
		}
		if (response.error) {
			message.error(response.error.message, 5);
			return;
		}
		message.success("Successfully saved the options");
	});

	loadOptions = flow(function*(options) {
		this.initUI();
		const response = yield getOptions();
		if (response == null) {
			message.error("Failed to get options. Unexpected error", 3);
			return;
		}

		if (response.error) {
			message.error("Failed to get options. Error: " + response.error.message);
			return;
		}

		this.options = observable.object(response.options);
		this.proxies = observable.array(response.proxies);
		this.blockedSites = observable.array(response.blockedSites);
		this.proxyMonitorState = response.proxyMonitorState;		

		const { tab } = options;
		if (tab) {
			this.ui.initTab = tab;
		}
		this.stateForm = observable.object(this.createStateForm(this.options));

		registerHandler([
			{
				path: "proxies",
				handler: function(err, msg) {
					if (err) {
						return;
					}
					let obj = JSON.parse(msg.body);
					// console.log(obj);
					if (obj.action == "proxyStatusChanged") {						
						this.updateProxy(obj.proxy);
					}
					if (obj.action == "proxiesDeleted") {
						this.deleteProxies(obj.proxies);
					}
					if (obj.action == "proxyMonitorStateChanged") {
						this.changeProxyMonitorState(obj.state);
					}
				}.bind(this)
			}, 
			{
				path: "blocked_sites",
				handler: function(err, msg) {
					if (err) {
						return;
					}
					let obj = JSON.parse(msg.body);
					if (obj.action == "blockedSitesAdded") {
						this.addBlockedSites(obj.siteList);
					}
					if (obj.action == "blockedSitesDeleted") {
						this.deleteBlockedSites(obj.siteList);
					}
				}.bind(this)
			}
		]);
	});
}

export default OptionsStore;
